// src/components/Header.js
import React from 'react';
import { Flag } from 'lucide-react';
import { APP_TAGLINE, ELECTION_YEAR } from '../utils/theme';
import './Header.css';

const Header = ({ tagline }) => {
  return (
    <header className="header">
      <a href="https://votergo.app" className="header-logo-wrap" aria-label="Back to VoterGO">
        <div className="header-elephant">
          <img src="/logo.png" alt="VoterGO" style={{width: '100%', height: '100%',
      objectFit: 'contain', objectPosition: 'center'
    }}
  />
</div>
        <div className="header-text">
          <div className="header-wordmark">
            <span className="header-larimer">Voter</span>
            <span className="header-go">GO</span>
          </div>
          <div className="header-tagline">{tagline || APP_TAGLINE}</div>
        </div>
      </a>
      <div className="header-right">
        <span className="election-tag">
          <Flag size={16} color="currentColor" style={{ verticalAlign: 'middle' }} /> {ELECTION_YEAR} Election
        </span>
      </div>
    </header>
  );
};

export default Header;
